import { gql } from '@apollo/client'

const GET_COHORT_BY_ID = gql`
  query Cohort($id: Int!) {
    cohort(id: $id) {
      id
      name
      startDate
      endDate
      createdAt
      updatedAt
      memberRoles
      cohortOwnerships {
        id
        funderOrg {
          id
          name
          disabled
        }
      }
      cohortMemberships {
        id
        startDate
        endDate
        nonprofitOrg {
          id
          name
        }
      }
    }
  }
`

export default GET_COHORT_BY_ID
